// Categorized top 100 US links (sample, extend as needed)
export const POPULAR_LINKS = [
  {
    category: "Productivity",
    links: [
      { name: "Google Drive", url: "https://drive.google.com" },
      { name: "Notion", url: "https://notion.so" },
      { name: "Slack", url: "https://slack.com" },
      { name: "Trello", url: "https://trello.com" },
      { name: "Asana", url: "https://asana.com" },
      { name: "Dropbox", url: "https://dropbox.com" },
      { name: "Evernote", url: "https://evernote.com" },
      { name: "Zoom", url: "https://zoom.us" },
      { name: "Calendly", url: "https://calendly.com" },
      { name: "Todoist", url: "https://todoist.com" },
    ],
  },
  {
    category: "Banking/Finance",
    links: [
      { name: "Chase", url: "https://chase.com" },
      { name: "Bank of America", url: "https://bankofamerica.com" },
      { name: "Wells Fargo", url: "https://wellsfargo.com" },
      { name: "PayPal", url: "https://paypal.com" },
      { name: "American Express", url: "https://americanexpress.com" },
      { name: "Capital One", url: "https://capitalone.com" },
      { name: "Venmo", url: "https://venmo.com" },
      { name: "Robinhood", url: "https://robinhood.com" },
      { name: "Fidelity", url: "https://fidelity.com" },
      { name: "Charles Schwab", url: "https://schwab.com" },
    ],
  },
  {
    category: "Shopping",
    links: [
      { name: "Amazon", url: "https://amazon.com" },
      { name: "eBay", url: "https://ebay.com" },
      { name: "Walmart", url: "https://walmart.com" },
      { name: "Target", url: "https://target.com" },
      { name: "Best Buy", url: "https://bestbuy.com" },
      { name: "Costco", url: "https://costco.com" },
      { name: "Home Depot", url: "https://homedepot.com" },
      { name: "Etsy", url: "https://etsy.com" },
      { name: "Macy's", url: "https://macys.com" },
      { name: "Kohl's", url: "https://kohls.com" },
    ],
  },
  {
    category: "Travel",
    links: [
      { name: "Expedia", url: "https://expedia.com" },
      { name: "Airbnb", url: "https://airbnb.com" },
      { name: "Booking.com", url: "https://booking.com" },
      { name: "Google Maps", url: "https://maps.google.com" },
      { name: "TripAdvisor", url: "https://tripadvisor.com" },
      { name: "Uber", url: "https://uber.com" },
      { name: "Lyft", url: "https://lyft.com" },
      { name: "Hotels.com", url: "https://hotels.com" },
      { name: "Southwest Airlines", url: "https://southwest.com" },
      { name: "Delta", url: "https://delta.com" },
    ],
  },
  {
    category: "News",
    links: [
      { name: "CNN", url: "https://cnn.com" },
      { name: "NYTimes", url: "https://nytimes.com" },
      { name: "BBC", url: "https://bbc.com" },
      { name: "Ground News", url: "https://ground.news" },
      { name: "NPR", url: "https://npr.org" },
      { name: "Reuters", url: "https://reuters.com" },
      { name: "Washington Post", url: "https://washingtonpost.com" },
      { name: "Bloomberg", url: "https://bloomberg.com" },
      { name: "USA Today", url: "https://usatoday.com" },
      { name: "Yahoo News", url: "https://news.yahoo.com" },
    ],
  },
  {
    category: "Social",
    links: [
      { name: "Facebook", url: "https://facebook.com" },
      { name: "Instagram", url: "https://instagram.com" },
      { name: "Twitter (X)", url: "https://twitter.com" },
      { name: "LinkedIn", url: "https://linkedin.com" },
      { name: "Reddit", url: "https://reddit.com" },
      { name: "Pinterest", url: "https://pinterest.com" },
      { name: "Snapchat", url: "https://snapchat.com" },
      { name: "TikTok", url: "https://tiktok.com" },
      { name: "Tumblr", url: "https://tumblr.com" },
      { name: "Quora", url: "https://quora.com" },
    ],
  },
  {
    category: "Entertainment",
    links: [
      { name: "YouTube", url: "https://youtube.com" },
      { name: "Netflix", url: "https://netflix.com" },
      { name: "Spotify", url: "https://spotify.com" },
      { name: "Hulu", url: "https://hulu.com" },
      { name: "Disney+", url: "https://disneyplus.com" },
      { name: "Twitch", url: "https://twitch.tv" },
      { name: "HBO Max", url: "https://hbomax.com" },
      { name: "Apple Music", url: "https://music.apple.com" },
      { name: "SoundCloud", url: "https://soundcloud.com" },
      { name: "Pandora", url: "https://pandora.com" },
    ],
  },
  {
    category: "Tools",
    links: [
      { name: "Canva", url: "https://canva.com" },
      { name: "Grammarly", url: "https://grammarly.com" },
      { name: "GitHub", url: "https://github.com" },
      { name: "Bitbucket", url: "https://bitbucket.org" },
      { name: "Stack Overflow", url: "https://stackoverflow.com" },
      { name: "IFTTT", url: "https://ifttt.com" },
      { name: "Zapier", url: "https://zapier.com" },
      { name: "WeTransfer", url: "https://wetransfer.com" },
      { name: "TinyURL", url: "https://tinyurl.com" },
      { name: "Mailchimp", url: "https://mailchimp.com" },
    ],
  },
  {
    category: "Health",
    links: [
      { name: "WebMD", url: "https://webmd.com" },
      { name: "Mayo Clinic", url: "https://mayoclinic.org" },
      { name: "Healthline", url: "https://healthline.com" },
      { name: "CDC", url: "https://cdc.gov" },
      { name: "NIH", url: "https://nih.gov" },
      { name: "Cleveland Clinic", url: "https://my.clevelandclinic.org" },
      { name: "GoodRx", url: "https://goodrx.com" },
      { name: "Zocdoc", url: "https://zocdoc.com" },
      { name: "Planned Parenthood", url: "https://plannedparenthood.org" },
      { name: "Walgreens Pharmacy", url: "https://walgreens.com/pharmacy" },
    ],
  },
  {
    category: "Government",
    links: [
      { name: "IRS", url: "https://irs.gov" },
      { name: "USPS", url: "https://usps.com" },
      { name: "Social Security", url: "https://ssa.gov" },
      { name: "DMV", url: "https://dmv.org" },
      { name: "USA.gov", url: "https://usa.gov" },
      { name: "NASA", url: "https://nasa.gov" },
      { name: "Congress.gov", url: "https://congress.gov" },
      { name: "CDC", url: "https://cdc.gov" },
      { name: "FEMA", url: "https://fema.gov" },
      {
        name: "Contact Your Representative",
        url: "https://www.house.gov/representatives/find-your-representative",
      },
      { name: "State Dept.", url: "https://state.gov" },
    ],
  },
  {
    category: "Sports",
    links: [
      { name: "ESPN", url: "https://espn.com" },
      { name: "Bleacher Report", url: "https://bleacherreport.com" },
      { name: "Yahoo Sports", url: "https://sports.yahoo.com" },
      { name: "CBS Sports", url: "https://cbssports.com" },
      { name: "NBC Sports", url: "https://nbcsports.com" },
      { name: "FOX Sports", url: "https://foxsports.com" },
      { name: "NBA", url: "https://nba.com" },
      { name: "NFL", url: "https://nfl.com" },
      { name: "MLB", url: "https://mlb.com" },
      { name: "NHL", url: "https://nhl.com" },
    ],
  },
  {
    category: "Blogs and Podcasts",
    links: [
      { name: "The Verge", url: "https://theverge.com" },
      { name: "Stratechery", url: "https://stratechery.com" },
      { name: "Freakonomics Radio", url: "https://freakonomics.com" },
      { name: "The Daily (NYT)", url: "https://nytimes.com/column/the-daily" },
      { name: "Radiolab", url: "https://radiolab.org" },
      { name: "TED Talks", url: "https://ted.com/podcasts" },
      {
        name: "Wait Wait... Don't Tell Me!",
        url: "https://npr.org/programs/wait-wait-dont-tell-me/",
      },
      { name: "Comedy Bang! Bang!", url: "https://cbbworld.com" },
      { name: "Planet Money", url: "https://npr.org/sections/money/" },
      { name: "99% Invisible", url: "https://99percentinvisible.org" },
    ],
  },
  {
    category: "Indie Publishing",
    links: [
      { name: "Substack", url: "https://substack.com" },
      { name: "Ghost", url: "https://ghost.org" },
      { name: "Medium", url: "https://medium.com" },
      { name: "Blurb", url: "https://blurb.com" },
      { name: "Gumroad", url: "https://gumroad.com" },
      { name: "itch.io", url: "https://itch.io" },
      { name: "BookBaby", url: "https://bookbaby.com" },
      { name: "Lulu", url: "https://lulu.com" },
      { name: "Leanpub", url: "https://leanpub.com" },
      { name: "Pressbooks", url: "https://pressbooks.com" },
    ],
  },
  {
    category: "AI Tools",
    links: [
      { name: "ChatGPT", url: "https://chat.openai.com/" },
      { name: "Claude", url: "https://claude.ai/" },
      { name: "Gemini", url: "https://gemini.google.com/" },
      { name: "Perplexity AI", url: "https://www.perplexity.ai/" },
      { name: "Poe", url: "https://poe.com/" },
      { name: "Midjourney", url: "https://www.midjourney.com/" },
      { name: "Notion AI", url: "https://www.notion.so/product/ai" },
      { name: "Microsoft Copilot", url: "https://copilot.microsoft.com/" },
      { name: "Hugging Face Spaces", url: "https://huggingface.co/spaces" },
      { name: "Leonardo AI", url: "https://leonardo.ai/" },
      { name: "Stable Diffusion", url: "https://stablediffusionweb.com/" },
      { name: "Cohere", url: "https://cohere.com/" },
    ],
  },
];
